import { Chain } from './tokens'

// DO NOT MODIFY THIS FILE MANUALLY
// This file is auto-generated by scripts/chaingen.ts
export type SupportedChainIds =
  | 'polkadot'
  | 'astar'
  | 'hydradx'
  | 'kusama'
  | 'bittensor'
  | 'polkadot-asset-hub'
  | 'kusama-asset-hub'
  | 'bifrost-polkadot'
  | 'moonbeam'
  | 'phala'
  | 'mythos'
export const supportedChains: Chain<SupportedChainIds>[] = [
  {
    id: 'polkadot',
    chainName: 'Polkadot',
    genesisHash: '0x91b171bb158e2d3848fa23a9f1c25182fb8e20313b2c1eb49219da7a70ce90c3',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/polkadot.svg',
    nativeToken: {
      id: 'polkadot-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://polkadot.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://rpc.ibp.network/polkadot',
      },
      {
        url: 'wss://rpc.dotters.network/polkadot',
      },
      {
        url: 'wss://1rpc.io/dot',
      },
      {
        url: 'wss://polkadot-rpc.dwellir.com',
      },
      {
        url: 'wss://polkadot-rpc-tn.dwellir.com',
      },
      {
        url: 'wss://polkadot-rpc.publicnode.com',
      },
      {
        url: 'wss://polkadot-public-rpc.blockops.network/ws',
      },
      {
        url: 'wss://rpc-polkadot.luckyfriday.io',
      },
      {
        url: 'wss://polkadot.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://rockx-dot.w3node.com/polka-public-dot/ws',
      },
      {
        url: 'wss://dot-rpc.stakeworld.io',
      },
    ],
    ss58Prefix: 0,
    subscanUrl: 'https://polkadot.subscan.io/',
    polkaAssemblyUrl: 'https://polkadot.polkassembly.io',
    account: '*25519',
    isDisabled: true,
  },
  {
    id: 'astar',
    chainName: 'Astar',
    genesisHash: '0x9eb76c5184c4ab8679d2d5d819fdf90b9c001403e9e17da2e14b6d8aec4029c6',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/astar.svg',
    nativeToken: {
      id: 'astar-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://astar.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://1rpc.io/astr',
      },
      {
        url: 'wss://astar-rpc.dwellir.com',
      },
      {
        url: 'wss://rpc.astar.network',
      },
      {
        url: 'wss://astar.public.curie.radiumblock.co/ws',
      },
    ],
    ss58Prefix: 5,
    subscanUrl: 'https://astar.subscan.io/',
    polkaAssemblyUrl: 'https://astar.polkassembly.io',
    account: '*25519',
  },
  {
    id: 'hydradx',
    chainName: 'Hydration',
    genesisHash: '0xafdc188f45c71dacbaa0b62e16a91f726c7b8699a9748cdf715459de6b7f366d',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/hydradx.svg',
    nativeToken: {
      id: 'hydradx-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://hydradx-rpc.dwellir.com',
      },
      {
        url: 'wss://hydration.ibp.network',
      },
      {
        url: 'wss://hydration.dotters.network',
      },
      {
        url: 'wss://rpc.hydradx.cloud',
      },
      {
        url: 'wss://rpc.helikon.io/hydradx',
      },
      {
        url: 'wss://hydradx.paras.ibp.network',
      },
      {
        url: 'wss://hydradx.paras.dotters.network',
      },
    ],
    ss58Prefix: 63,
    subscanUrl: 'https://hydration.subscan.io/',
    polkaAssemblyUrl: 'https://centrifuge.polkassembly.io',
    account: '*25519',
  },
  {
    id: 'kusama',
    chainName: 'Kusama',
    genesisHash: '0xb0a8d493285c2df73290dfb7e61f870f17b41801197a149ca93654499ea3dafe',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/kusama.svg',
    nativeToken: {
      id: 'kusama-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://kusama.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://rpc.ibp.network/kusama',
      },
      {
        url: 'wss://rpc.dotters.network/kusama',
      },
      {
        url: 'wss://1rpc.io/ksm',
      },
      {
        url: 'wss://kusama-rpc.dwellir.com',
      },
      {
        url: 'wss://kusama-rpc-tn.dwellir.com',
      },
      {
        url: 'wss://kusama-rpc.publicnode.com',
      },
      {
        url: 'wss://rpc-kusama.luckyfriday.io',
      },
      {
        url: 'wss://kusama.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://rockx-ksm.w3node.com/polka-public-ksm/ws',
      },
      {
        url: 'wss://ksm-rpc.stakeworld.io',
      },
    ],
    ss58Prefix: 2,
    subscanUrl: 'https://kusama.subscan.io/',
    polkaAssemblyUrl: 'https://kusama.polkassembly.io',
    account: '*25519',
  },
  {
    id: 'bittensor',
    chainName: 'Bittensor',
    genesisHash: '0x2f0555cc76fc2840a25a6ea3b9637146806f1f44b090c175ffde2a7e5ab36c03',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/bittensor.svg',
    nativeToken: {
      id: 'bittensor-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://bittensor-finney.api.onfinality.io/ws?apikey=',
      },
      {
        url: 'wss://entrypoint-finney.opentensor.ai:443',
      },
    ],
    ss58Prefix: 42,
    subscanUrl: 'https://bittensor.com/scan',
    account: '*25519',
  },
  {
    id: 'polkadot-asset-hub',
    chainName: 'Polkadot Asset Hub',
    genesisHash: '0x68d56f15f85d3136970ec16946040bc1752654e906147f7e43e9d539d7c3de2f',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/polkadot-asset-hub.svg',
    nativeToken: {
      id: 'polkadot-asset-hub-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://statemint.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://sys.ibp.network/statemint',
      },
      {
        url: 'wss://sys.dotters.network/statemint',
      },
      {
        url: 'wss://sys.ibp.network/asset-hub-polkadot',
      },
      {
        url: 'wss://sys.dotters.network/asset-hub-polkadot',
      },
      {
        url: 'wss://asset-hub-polkadot-rpc.dwellir.com',
      },
      {
        url: 'wss://statemint-rpc-tn.dwellir.com',
      },
      {
        url: 'wss://rpc-asset-hub-polkadot.luckyfriday.io',
      },
      {
        url: 'wss://polkadot-asset-hub-rpc.polkadot.io',
      },
      {
        url: 'wss://statemint.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://dot-rpc.stakeworld.io/assethub',
      },
    ],
    ss58Prefix: 0,
    subscanUrl: 'https://assethub-polkadot.subscan.io/',
    account: '*25519',
  },
  {
    id: 'kusama-asset-hub',
    chainName: 'Kusama Asset Hub',
    genesisHash: '0x48239ef607d7928874027a43a67689209727dfb3d3dc5e5b03a39bdc2eda771a',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/kusama-asset-hub.svg',
    nativeToken: {
      id: 'kusama-asset-hub-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://assethub-kusama.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://sys.ibp.network/statemine',
      },
      {
        url: 'wss://sys.dotters.network/statemine',
      },
      {
        url: 'wss://asset-hub-kusama-rpc.dwellir.com',
      },
      {
        url: 'wss://statemine-rpc-tn.dwellir.com',
      },
      {
        url: 'wss://rpc-asset-hub-kusama.luckyfriday.io',
      },
      {
        url: 'wss://kusama-asset-hub-rpc.polkadot.io',
      },
      {
        url: 'wss://statemine.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://ksm-rpc.stakeworld.io/assethub',
      },
    ],
    ss58Prefix: 2,
    subscanUrl: 'https://assethub-kusama.subscan.io/',
    account: '*25519',
  },
  {
    id: 'bifrost-polkadot',
    chainName: 'Bifrost Polkadot',
    genesisHash: '0x262e1b2ad728475fd6fe88e62d34c200abe6fd693931ddad144059b1eb884e5b',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/bifrost-polkadot.svg',
    nativeToken: {
      id: 'bifrost-polkadot-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://bifrost-polkadot-rpc.dwellir.com',
      },
      {
        url: 'wss://bifrost-polkadot.ibp.network',
      },
      {
        url: 'wss://bifrost-polkadot.dotters.network',
      },
      {
        url: 'wss://hk.p.bifrost-rpc.liebi.com/ws',
      },
      {
        url: 'wss://eu.bifrost-polkadot-rpc.liebi.com/ws',
      },
      {
        url: 'wss://bifrost.public.curie.radiumblock.co/ws',
      },
    ],
    ss58Prefix: 6,
    subscanUrl: 'https://bifrost.subscan.io/',
    account: '*25519',
  },
  {
    id: 'moonbeam',
    chainName: 'Moonbeam',
    genesisHash: '0xfe58ea77779b7abda7da4ec526d14db9b1e9cd40a217c34892af80a9b332b76d',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/moonbeam.svg',
    nativeToken: {
      id: 'moonbeam-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://moonbeam.api.onfinality.io/rpc?apikey=',
      },
      {
        url: 'wss://moonbeam-rpc.dwellir.com',
      },
      {
        url: 'wss://moonbeam.ibp.network',
      },
      {
        url: 'wss://moonbeam.dotters.network',
      },
      {
        url: 'wss://moonbeam-rpc.publicnode.com',
      },
      {
        url: 'wss://wss.api.moonbeam.network',
      },
      {
        url: 'wss://moonbeam.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://moonbeam.unitedbloc.com',
      },
    ],
    ss58Prefix: 1284,
    subscanUrl: 'https://moonbeam.subscan.io/',
    account: 'secp256k1',
  },
  {
    id: 'phala',
    chainName: 'Phala',
    genesisHash: '0x1bb969d85965e4bb5a651abbedf21a54b6b31a21f66b5401cc3f1e286268d736',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/phala.svg',
    nativeToken: {
      id: 'phala-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://phala-rpc.dwellir.com',
      },
      {
        url: 'wss://phala.public.curie.radiumblock.co/ws',
      },
      {
        url: 'wss://api.phala.network/ws',
      },
    ],
    ss58Prefix: 30,
    subscanUrl: 'https://phala.subscan.io/',
    account: '*25519',
  },
  {
    id: 'mythos',
    chainName: 'Mythos',
    genesisHash: '0xf6ee56e9c5277df5b4ce6ae9983ee88f3cbed27d31beeb98f9f84f997a1ab0b9',
    isTestnet: false,
    logo: 'https://raw.githubusercontent.com/TalismanSociety/chaindata/main/assets/chains/mythos.svg',
    nativeToken: {
      id: 'mythos-substrate-native',
    },
    rpcs: [
      {
        url: 'wss://polkadot-mythos-rpc.polkadot.io',
      },
    ],
    ss58Prefix: 42,
    subscanUrl: 'https://mythos.subscan.io/',
    account: 'secp256k1',
  },
]
